import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './MenuNav.css';

function MenuNav() {
  const { t } = useTranslation();

  return (
    <nav className="menu-nav" aria-label={t('nav.menuSection', 'Menú')}>
      <NavLink
        to="/menu"
        end
        className={({ isActive }) => `menu-nav__pill${isActive ? ' menu-nav__pill--active' : ''}`}
      >
        {t('nav.menu', 'Carta')}
      </NavLink>
      <NavLink
        to="/menu/modifiers"
        className={({ isActive }) => `menu-nav__pill${isActive ? ' menu-nav__pill--active' : ''}`}
      >
        {t('nav.modifiers', 'Modificadores')}
      </NavLink>
      <NavLink
        to="/menu/promo-rules"
        className={({ isActive }) => `menu-nav__pill${isActive ? ' menu-nav__pill--active' : ''}`}
      >
        {t('nav.promoRules', 'Promociones')}
      </NavLink>
    </nav>
  );
}

export default MenuNav;
